<template>
    <AuditRequestView 
		:preview="preview" 
		:previewID="previewID == 0 ? parseInt(this.$route.params.id) : previewID"
		:submitterName="submitterName"
	></AuditRequestView>
</template>

<script>
import AuditRequestView from "./AuditRequestView.vue"
export default {
	name: "TemplatePreview",
	components: {
		AuditRequestView
	},
	props: {
		preview: {
			type: Boolean,
			default: true,
		},
		previewID: {
			type: Number,
			default: 0,
		},
		submitterName: {
			type: String,
			default: null
		}
	},
}
</script>